var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.68421 4H15.3158C16.0277 4 16.7104 4.27393 17.2138 4.76152C17.7172 5.24912 18 5.91044 18 6.6V14.4C18 15.0896 17.7172 15.7509 17.2138 16.2385C16.7104 16.7261 16.0277 17 15.3158 17H3.68421C2.97231 17 2.28957 16.7261 1.78619 16.2385C1.2828 15.7509 1 15.0896 1 14.4V6.6C1 5.91044 1.2828 5.24912 1.78619 4.76152C2.28957 4.27393 2.97231 4 3.68421 4ZM3.68421 4.86667C3.23684 4.86667 2.84316 5.014 2.53895 5.274L9.5 9.63333L16.4611 5.274C16.1568 5.014 15.7632 4.86667 15.3158 4.86667H3.68421ZM9.5 10.682L2.01105 5.976C1.93947 6.16667 1.89474 6.38333 1.89474 6.6V14.4C1.89474 14.8597 2.08327 15.3006 2.41886 15.6257C2.75445 15.9507 3.20961 16.1333 3.68421 16.1333H15.3158C15.7904 16.1333 16.2455 15.9507 16.5811 15.6257C16.9167 15.3006 17.1053 14.8597 17.1053 14.4V6.6C17.1053 6.38333 17.0605 6.16667 16.9889 5.976L9.5 10.682Z",
    fill: "#435869"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.03f3744fd7def1b354474752e9fe5a46.svg";
export { ForwardRef as ReactComponent };